import { type RemoveHookResponse, mutationRemove } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useDispositionCache } from './cache'
import { type DispositionRemoveInput, type DispositionRemoveSuccess, toResponseError } from '@terros/common'

export function useRemoveDisposition(): RemoveHookResponse<DispositionRemoveInput> {
  const mutation = useTantalimMutation<DispositionRemoveInput, DispositionRemoveSuccess>({
    url: '/disposition/remove',
  })
  const cache = useDispositionCache()
  async function remove(input: DispositionRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.dispositionId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
